import React from 'react';
import { connect } from "react-redux";
import { updateData, updateFilterData, updateEditData } from "../actions";
import ControlService from '../../helper/controlservice';

function bindAction(dispatch) {
    return {
        update: (key, value, storekey) => dispatch(updateData(key, value, storekey)),
        updateEdit: (key, value) => dispatch(updateEditData(key, value)),
        updateFilter: (key, value, key2) => dispatch(updateFilterData(key, value, key2))
    };
}
const mapStateToProps = state => ({
    data: state.formDataReducer,
    filterdata: state.formDataReducer.filterdata,
    editformdata: state.formDataReducer.editformdata,
    token: state.formLoginReducer.token,
    hasErrored: state.formDataReducer.hasErrored,
    isLoading: state.formDataReducer.isLoading
});
class Number extends React.PureComponent {
    constructor() {
        super()

        this.state = {
            from: 0,
            to: 0,
            hide: true,
            Modeldata: null,
            touched: false,
            ValueChanged: false,
            error: ''
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        var data = nextProps.data[nextProps.formid] ? nextProps.data[nextProps.formid][nextProps.control.key] : null;
        if (data != prevState.data) {
            let lastVal = 'NA';
            let value = ControlService().isEmptyorNull(data) ? '' : data.toString();
            if (value && value.includes('.')) {
                let _lastVal = value.split('.')[1];
                lastVal = _lastVal;
            }
            return {
                data: data,
                Modeldata: lastVal === 'NA' ? value : (parseInt(value) + '.' + lastVal)
            }
        } else return null;
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.data != this.state.data) {
            if (!this.state.ValueChanged) {
                this.Format(this.props.formid, this.props.control);
            }
            this.setState({
                ValueChanged: false,
            });
            this.controlVaildationCheck(this.props);
        }
    }

    componentDidMount() {
        this.controlVaildationCheck(this.props);
        if (this.props.action == "filter") {
            const data = this.props.filterdata[this.props.control.key];
            if (data) {
                this.setState({
                    from: data.from,
                    to: data.to
                })
            }
        } else {
            const { control, formid } = this.props;
            this.setDefaultValue(control, formid, control);
        }
    }
    setDefaultValue(control, formid) {
        var data = this.props.data[formid] ? this.props.data[formid] : {};
        if (!data[control.key] && control.defaultvalue != null && control.defaultvalue != 'undefined' && control.defaultvalue !== '') {
            this.props.update(control.key, control.defaultvalue, formid)
            this.setState({ Modeldata: control.defaultvalue }, () => {
                this.Format(formid, control);
            });
        } else {
            this.setState({ Modeldata: data[control.key] }, () => {
                this.Format(formid, control);
            });
        }
        if (this.validate(control, data[control.key], data)) {
            this.props.update(control.key, { "status": "fail", "control": control, touched: false }, formid + "_validation");
        }
    }
    AllowNumericValue(event, control) {
        if (control.formatoption) {
            if (control.formatoption.format == "number") {
                if (control.formatoption.descimalplaces > 0)
                    return event.charCode === 0 || ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode == 46 && event.key == '.'));
                else if (control.formatoption.negativenumbers == "0")
                    return (event.charCode == 45 && event.key == '-') || String.fromCharCode(event.charCode).match(/[0-9]/g) != null;
                else
                    return String.fromCharCode(event.charCode).match(/[0-9]/g) != null;
            } else {
                if (control.formatoption.cdescimalplaces > 0)
                    return event.charCode === 0 || ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode == 46 && event.key == '.'));
                else if (control.formatoption.cnegativenumbers == "0")
                    return (event.charCode == 45 && event.key == '-') || String.fromCharCode(event.charCode).match(/[0-9]/g) != null;
                else
                    return String.fromCharCode(event.charCode).match(/[0-9]/g) != null;
            }
        }
        else
            return String.fromCharCode(event.charCode).match(/[0-9]/g) != null;
    }
    AllowOneDecimal(event, control) {
        var val = this.state.Modeldata ? this.state.Modeldata.toString() : "";
        if (control.formatoption.cnegativenumbers == "0" || control.formatoption.negativenumbers == "0")
            val = val.replace(/[^0-9\.-]/g, '');
        else
            val = val.replace(/[^0-9\.]/g, '');
        if (val.split('.').length > 2)
            val = val.replace(/\.+$/, "");

        this.setState({ Modeldata: val });
    }
    numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    validate(control, data, _dataModel) {
        let _return = false
        if (control.max && data > control.max) {
            this.setState({ error: (control.label ? control.label : control.placeholder) + ' should be less than ' + control.max + '.' });
            _return = true;
        } else if (control.min && data < control.min) {
            this.setState({ error: (control.label ? control.label : control.placeholder) + ' should be more than ' + control.min + '.' });
            _return = true;
        } else if (control.minmodel && data < _dataModel[control.minmodel]) {
            this.setState({ error: (control.label ? control.label : control.placeholder) + ' should be more than ' + _dataModel[control.minmodel] + '.' });
            _return = true;
        } else if (control.maxmodel && data > _dataModel[control.maxmodel]) {
            this.setState({ error: (control.label ? control.label : control.placeholder) + ' should be less than ' + _dataModel[control.maxmodel] + '.' });
            _return = true;
        } else {
            this.setState({ error: '' });
        }

        return _return;
    }
    Format(formid, control) {
        const symbol = { "0": "", "1": "$", "2": "₹", "3": "£", "4": "€", "5": "¥" };
        var data = this.props.data[formid] ? this.props.data[formid][control.key] : null;
        var _dataModel = this.props.data[formid] ? this.props.data[formid] : {};
        var { Modeldata } = this.state;
        if (this.validate(control, data, _dataModel)) {
            return;
        }
        if (!control.formatoption)
            return;
        var modeldata = Modeldata ? Modeldata.toString() : "";

        if (modeldata.length > 0) {
            if (modeldata.indexOf("-") > -1) {
                modeldata = modeldata.replace(/-/g, '');
            }

            if (!modeldata.substring(0, 1).match(/[0-9]/g)) {
                modeldata = modeldata.substring(1);
            }
        }
        if (modeldata.trim() == "") {
            this.setState({ Modeldata: modeldata });
            // this.props.update(control.key, value ? value : null, formid);
            return;
        }
        var dataDecimal = modeldata.split(".")
        var BeforeDecimal = dataDecimal[0];
        var AfterDecimal = dataDecimal.length > 1 ? dataDecimal[1] : "";

        var descimalplaces = "";
        if (control.formatoption.format == "number") {
            for (let i = 0; i < control.formatoption.descimalplaces; i++) {
                if (AfterDecimal.length > i) {
                    descimalplaces = descimalplaces + AfterDecimal.substr(i, 1);
                }
                else {
                    descimalplaces = descimalplaces + "0";
                }
            }
            if (descimalplaces == "") {
                AfterDecimal = "";
            }
            else {
                AfterDecimal = "." + descimalplaces;
            }
            if (control.formatoption.separator == true)
                BeforeDecimal = this.numberWithCommas(BeforeDecimal);

            if (control.formatoption.negativenumbers == "0")
                modeldata = "-" + BeforeDecimal + AfterDecimal;
            else
                modeldata = BeforeDecimal + AfterDecimal;
        }
        else if (control.formatoption.format == "currency") {
            for (let i = 0; i < control.formatoption.cdescimalplaces; i++) {
                if (AfterDecimal.length > i) {
                    descimalplaces = descimalplaces + AfterDecimal.substr(i, 1);
                }
                else {
                    descimalplaces = descimalplaces + "0";
                }
            }
            if (descimalplaces == "") {
                AfterDecimal = "";
            }
            else {
                AfterDecimal = "." + descimalplaces;
            }
            BeforeDecimal = this.numberWithCommas(BeforeDecimal);
            BeforeDecimal = (symbol[control.formatoption.symbol] ? symbol[control.formatoption.symbol] : "") + BeforeDecimal;

            if (control.formatoption.cnegativenumbers == "0")
                modeldata = "-" + BeforeDecimal + AfterDecimal;
            else
                modeldata = BeforeDecimal + AfterDecimal;
        }
        this.setState({ Modeldata: modeldata, error: '' });

    }
    updateFilter(value, key) {
        this.props.updateFilter(this.props.control.key, value, key)
        if (key == "from") {
            this.setState({ from: value });
        } else {
            this.setState({ to: value });
        }
    }
    onValueChange(_value, control, action, formid) {
        debugger;
        if (_value.toString() !== 'NaN') {
            let value = _value.replace(/[^0-9.-]+/g, "");
            value = value.replace(/-/g, "")
            if (value == '.') {
                value = '0.';
            }
            if (control.formatoption.negativenumbers == "0" || control.formatoption.cnegativenumbers == "0") {
                value = value ? -Math.abs(value) : null;
            } else {
                value = value ? Math.abs(value) : null;
            }
            var _dataModel = this.props.data[formid] ? this.props.data[formid] : {};
            if (this.validate(control, value, _dataModel)) {
                this.props.update(control.key, { "status": "fail", "control": control, touched: false }, this.props.formid + "_validation");
            }
            this.setState({
                ValueChanged: true,
            });
            this.props.update(control.key, value, formid);
            if (value === _dataModel[control.key]) {
                this.setState({ Modeldata: _value });
            }
        }
    }
    controlVaildationCheck(props) {
        const { control, formid, data } = props;
        var _data = data[formid] ? data[formid][control.key] : null
        var validation = ControlService().validate(control, _data);
        if (validation && !this.state.error) {
            this.props.update(control.key, { "status": "pass", "control": control, touched: false }, this.props.formid + "_validation")
        } else {
            this.props.update(control.key, { "status": "fail", "control": control, touched: false }, this.props.formid + "_validation")
        }
    }
    handleBlur = () => {
        this.setState({
            touched: true,
        });
    }
    onMouseDown = () => {
        var data = this.props.data[this.props.formid] && this.props.data[this.props.formid][this.props.control.key] ? this.props.data[this.props.formid][this.props.control.key] : '0';
        if (data === '0') {
            this.setState({ Modeldata: '' });
        }
    }
    shouldMarkError(control, data) {
        const validate = ControlService().validate(control, data[control.key]);

        const validation = this.props.data[this.props.formid + "_validation"] ? this.props.data[this.props.formid + "_validation"][control.key] : null;
        const isTouchedOutside = validation ? validation.touched : false;
        const shouldShow = this.state.touched || isTouchedOutside;
        return validate && !this.state.error ? !validate : shouldShow;
    }
    render() {

        const { control, action, formid } = this.props;
        var data = this.props.data[formid] ? this.props.data[formid] : {};
        const shouldMarkError = this.shouldMarkError(control, data);
        if (action == 'write') {
            return (
                <div className="form-group">
                    {control.label &&
                        <label htmlFor={control.id}>
                            {control.label}
                            {control.require &&
                                <sup className="text-danger font-weight-bold">*</sup>
                            }
                            {control.showhelptext &&
                                <span className={"custom-tooltip"}>
                                    <i className={"fa fa-question-circle ml-2 help-text"}></i>
                                    <span className={"tooltip tooltip-" + control.helpdirection}>{control.help}</span>
                                </span>
                            }
                        </label>
                    }
                    {control.imageurl &&
                        <img src={control.imageurl} width="100" height="100" alt={column.label} className="mb-2 img-fluid" />
                    }
                    <input autoComplete="off"
                        aria-label={control.label}
                        onMouseDown={this.onMouseDown}
                        onKeyDown={(e) => this.AllowNumericValue(e, control)}
                        onKeyUp={(e) => this.AllowOneDecimal(e, control)}
                        id={control.id}
                        required={control.require}
                        placeholder={control.placeholder}
                        className={'form-control validate filter-input ' + (shouldMarkError ? " border-danger " : "") + (control.textalign == 'right' ? ' text-right ' : '')}
                        onBlur={() => { this.Format(formid, control); this.handleBlur(); }}
                        onChange={(e) => this.onValueChange(e.currentTarget.value, control, action, formid)}
                        value={this.state.Modeldata}
                        type="text"
                        disabled={this.props.disabled} />
                    {(shouldMarkError && !this.state.error) &&
                        <small className="form-text text-danger">
                            {control.errormsg ? control.errormsg : 'You must enter a ' + (control.label ? control.label : control.placeholder) + '.'}
                        </small>
                    }
                    {this.state.error &&
                        <small className="form-text text-danger">
                            {this.state.error}
                        </small>
                    }
                    {control.description &&
                        <div className="form-text">{control.description}</div>
                    }
                </div>
            );
        }
        else if (action == 'filter') {
            return (
                <div className="card mb-2">
                    <div className="card-header d-flex align-items-center pointer" onClick={() => this.setState({ hide: !this.state.hide })} >
                        <label className="mb-0 pr-2">{control.filterheader}</label>

                        {
                            this.state.hide ?
                                <span className="ml-auto"> <i className="fa fa-angle-up" aria-hidden="true"></i></span>
                                :
                                <span className="ml-auto"><i className="fa fa-angle-down" aria-hidden="true"></i></span>
                        }

                    </div>
                    <div className="card-body" hidden={!this.state.hide} >
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="" htmlFor="from">From</label>
                                    <input autoComplete="off" type="number" min="0" id="from"
                                        aria-label="From"
                                        placeholder={control.placeholder}
                                        onChange={(e) => this.updateFilter(e.currentTarget.value, "from")}
                                        value={this.state.from}
                                        className="form-control" />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="" htmlFor="to">To</label>
                                    <input autoComplete="off" type="number"
                                        aria-label="To"
                                        min="0"
                                        id="to"
                                        placeholder={control.placeholder}
                                        onChange={(e) => this.updateFilter(e.currentTarget.value, "to")}
                                        value={this.state.to}
                                        className="form-control" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            );
        } else {
            return (
                <div style={{ marginHorizontal: 10, marginBottom: 10 }}>
                    <span style={{ fontSize: 13 }}>{control.label}</span>
                    <span style={{ paddingLeft: 30, fontWeight: 'bold' }}>{this.props.editformdata[control.key]}</span>
                </div>
            );
        }
    }
}

export default connect(mapStateToProps, bindAction)(Number);